<template>
  <button :style="buttonStyle" :class="buttonClasses" @click="onClick" :iconColor="iconColor">
    <div class="button-content">
      <span v-if="icon" class="button-icon" :style="{ color: iconColor }">{{ icon }}</span>
      {{ label }}
    </div>
    <span v-if="tooltip" class="tooltip">{{ tooltip }}</span>
  </button>
</template>


<script>
export default {
  props: {
    label: [Number, String],
    icon: String,
    color: String,
    iconColor: String,
    flat: Boolean,
    disable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    tooltip: String,
  },
  computed: {
    buttonClasses() {
      return {
        'flat-button': this.flat,
        'ripple-effect': this.ripple,
      }
    },
    buttonStyle() {
      const bgcol = this.color ? `var(--${this.color}, #ff0000)` : 'transparent'
      return { 'background-color': bgcol }
    },
  },
  emits: ['click'],
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  color: var(--white);
  border: none;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--primary); // Default color
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
  position: relative;

  &.flat-button {
    background-color: transparent;
    color: black;
  }

  .button-icon {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
  }

  .tooltip {
    visibility: hidden;
    width: 120px;
    background-color: var(--tooltip);
    color: var(--white);
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    font-size: 14px;
    top: calc(100% + 5px);
    left: 50%;
    transform: translateX(-50%);
  }

  &:hover .tooltip {
    visibility: visible;
  }
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


